const SESSION_STORAGE_KEY = "shoppingCart";

export const saveShoppingCart = ({
  assetUuids,
  contentUuids,
  modelUuid,
  trainAction,
}: {
  assetUuids?: string[];
  contentUuids?: string[];
  modelUuid?: string;
  trainAction?: "train" | "retrain";
}) => {
  sessionStorage.setItem(
    SESSION_STORAGE_KEY,
    JSON.stringify({ assetUuids, contentUuids, modelUuid, trainAction }),
  );
};

export const getShoppingCart = (): any => {
  const shoppingCart = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!shoppingCart) return null;
  return JSON.parse(shoppingCart);
};

export const clearShoppingCart = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
